import { Link, useLocation } from "react-router-dom";
import { Home, CalendarCheck, User, Trophy, Users } from "lucide-react";

const items = [
    { to: "/", label: "Home", icon: Home, testid: "nav-home" },
    { to: "/events", label: "Events", icon: Trophy, testid: "nav-events" },
    { to: "/community", label: "Players", icon: Users, testid: "nav-community" },
    { to: "/bookings", label: "Bookings", icon: CalendarCheck, testid: "nav-bookings" },
    { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
    const { pathname } = useLocation();
    return (
        <nav
            data-testid="bottom-nav"
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-950/90 backdrop-blur-xl border-t border-slate-800"
        >
            <ul className="grid grid-cols-5 h-16">
                {items.map(({ to, label, icon: Icon, testid }) => {
                    const active = pathname === to || (to !== "/" && pathname.startsWith(to));
                    return (
                        <li key={to}>
                            <Link
                                to={to}
                                data-testid={testid}
                                className={`flex flex-col items-center justify-center h-full gap-1 transition-colors ${
                                    active ? "text-[#00FF66]" : "text-slate-400 hover:text-slate-200"
                                }`}
                            >
                                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
                                <span className="text-[9px] font-bold tracking-widest uppercase">{label}</span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
